/**
 * 键盘键码映射表
 * 格式: [keyCode, [code, key, displayName]]
 * 核心规则：
 * 1. code: 物理按键标识（W3C标准，如 KeyA、MetaLeft）
 * 2. key: 按键输出/功能名（如 'a'、'Meta'、'ArrowLeft'）
 * 3. displayName: UI展示名（兼顾Windows/Mac）
 */
const keyMap = new Map([
  // 基础控制键
  [8,  ['Backspace', 'Backspace', 'Backspace']],
  [9,  ['Tab', 'Tab', 'Tab']],
  [13, ['Enter', 'Enter', 'Enter']],
  [19, ['Pause', 'Pause', 'Pause']],
  [20, ['CapsLock', 'CapsLock', 'CapsLock']],
  [27, ['Escape', 'Escape', 'Esc']],
  [32, ['Space', ' ', 'Space']],
  [33, ['PageUp', 'PageUp', 'PgUp']],
  [34, ['PageDown', 'PageDown', 'PgDn']],
  [35, ['End', 'End', 'End']],
  [36, ['Home', 'Home', 'Home']],

  // 方向键（key 严格按W3C标准）
  [37, ['ArrowLeft', 'ArrowLeft', '←']],
  [38, ['ArrowUp', 'ArrowUp', '↑']],
  [39, ['ArrowRight', 'ArrowRight', '→']],
  [40, ['ArrowDown', 'ArrowDown', '↓']],

  // 编辑键
  [45, ['Insert', 'Insert', 'Insert']],
  [46, ['Delete', 'Delete', 'Delete']],
  [44, ['PrintScreen', 'PrintScreen', 'PrintScreen']],

  // 主键盘数字键
  [48, ['Digit0', '0', '0']],
  [49, ['Digit1', '1', '1']],
  [50, ['Digit2', '2', '2']],
  [51, ['Digit3', '3', '3']],
  [52, ['Digit4', '4', '4']],
  [53, ['Digit5', '5', '5']],
  [54, ['Digit6', '6', '6']],
  [55, ['Digit7', '7', '7']],
  [56, ['Digit8', '8', '8']],
  [57, ['Digit9', '9', '9']],

  // 字母键（key 为小写，displayName 为大写）
  [65, ['KeyA', 'a', 'A']],
  [66, ['KeyB', 'b', 'B']],
  [67, ['KeyC', 'c', 'C']],
  [68, ['KeyD', 'd', 'D']],
  [69, ['KeyE', 'e', 'E']],
  [70, ['KeyF', 'f', 'F']],
  [71, ['KeyG', 'g', 'G']],
  [72, ['KeyH', 'h', 'H']],
  [73, ['KeyI', 'i', 'I']],
  [74, ['KeyJ', 'j', 'J']],
  [75, ['KeyK', 'k', 'K']],
  [76, ['KeyL', 'l', 'L']],
  [77, ['KeyM', 'm', 'M']],
  [78, ['KeyN', 'n', 'N']],
  [79, ['KeyO', 'o', 'O']],
  [80, ['KeyP', 'p', 'P']],
  [81, ['KeyQ', 'q', 'Q']],
  [82, ['KeyR', 'r', 'R']],
  [83, ['KeyS', 's', 'S']],
  [84, ['KeyT', 't', 'T']],
  [85, ['KeyU', 'u', 'U']],
  [86, ['KeyV', 'v', 'V']],
  [87, ['KeyW', 'w', 'W']],
  [88, ['KeyX', 'x', 'X']],
  [89, ['KeyY', 'y', 'Y']],
  [90, ['KeyZ', 'z', 'Z']],

  // F1-F12（无重复，键码112-123）
  [112, ['F1', 'F1', 'F1']],
  [113, ['F2', 'F2', 'F2']],
  [114, ['F3', 'F3', 'F3']],
  [115, ['F4', 'F4', 'F4']],
  [116, ['F5', 'F5', 'F5']],
  [117, ['F6', 'F6', 'F6']],
  [118, ['F7', 'F7', 'F7']],
  [119, ['F8', 'F8', 'F8']],
  [120, ['F9', 'F9', 'F9']],
  [121, ['F10', 'F10', 'F10']],
  [122, ['F11', 'F11', 'F11']],
  [123, ['F12', 'F12', 'F12']],

  // 符号键（修正重复键码问题）
  [186, ['Semicolon', ';', ';']], // 原186重复映射F16，删除F16-F24（非通用）
  [187, ['Equal', '=', '=']],     // 原187重复映射F17，删除
  [188, ['Comma', ',', ',']],
  [189, ['Minus', '-', '-']],
  [190, ['Period', '.', '.']],
  [191, ['Slash', '/', '/']],
  [192, ['Backquote', '`', '`']], // 原192重复映射F22，删除
  [219, ['BracketLeft', '[', '[']],
  [220, ['Backslash', '\\', '\\']],
  [221, ['BracketRight', ']', ']']],
  [222, ['Quote', "'", "'"]],

  // 小键盘（独立键码，避免和主键盘混淆）
  [96,  ['Numpad0', '0', 'Num0']],
  [97,  ['Numpad1', '1', 'Num1']],
  [98,  ['Numpad2', '2', 'Num2']],
  [99,  ['Numpad3', '3', 'Num3']],
  [100, ['Numpad4', '4', 'Num4']],
  [101, ['Numpad5', '5', 'Num5']],
  [102, ['Numpad6', '6', 'Num6']],
  [103, ['Numpad7', '7', 'Num7']],
  [104, ['Numpad8', '8', 'Num8']],
  [105, ['Numpad9', '9', 'Num9']],
  [106, ['NumpadMultiply', '*', 'Num*']],
  [107, ['NumpadAdd', '+', 'Num+']],
  [109, ['NumpadSubtract', '-', 'Num-']],
  [110, ['NumpadDecimal', '.', 'Num.']],
  [111, ['NumpadDivide', '/', 'Num/']],
  [144, ['NumLock', 'NumLock', 'NumLock']],
  [145, ['ScrollLock', 'ScrollLock', 'ScrollLock']],

  // Meta/OS键（区分左右，兼容Windows/Mac）
  [91,  ['MetaLeft', 'Meta', 'Win/⌘']],  // Windows左Win / Mac左Command
  [92,  ['MetaRight', 'Meta', 'Win/⌘']], // Windows右Win / Mac右Command
  [93,  ['ContextMenu', 'ContextMenu', 'ContextMenu']], // 右键菜单键（非Meta）

  // 修饰键（区分左右，通用键码+独立键码）
  [16,  ['Shift', 'Shift', 'Shift']],    // 通用Shift（兼容旧代码）
  [160, ['ShiftLeft', 'Shift', 'Shift ←']],
  [161, ['ShiftRight', 'Shift', 'Shift →']],
  [17,  ['Control', 'Control', 'Ctrl']], // 通用Ctrl（兼容旧代码）
  [162, ['ControlLeft', 'Control', 'Ctrl ←']],
  [163, ['ControlRight', 'Control', 'Ctrl →']],
  [18,  ['Alt', 'Alt', 'Alt']],          // 通用Alt（兼容旧代码）
  [164, ['AltLeft', 'Alt', 'Alt ←']],
  [165, ['AltRight', 'Alt', 'AltGr →']], // 右Alt/AltGr（欧洲键盘）

  // 扩展F键（F13-F24，非通用，按需保留）
  [183, ['F13', 'F13', 'F13']],        // 真实F13键，无冲突
  [184, ['F14', 'F14', 'F14']],        // 真实F14键，无冲突
  [185, ['F15', 'F15', 'F15']],        // 真实F15键，无冲突
  [186, ['Semicolon', ';', ';']],    // 原错误标F16，实际是分号/冒号键（键盘标注 ;/:）
  [187, ['Equal', '=', '=']],        // 原错误标F17，实际是等号/加号键（键盘标注 =/+）
  [188, ['Comma', ',', ',']],        // 原错误标F18，实际是逗号/小于号键（键盘标注 ,/<）
  [189, ['Minus', '-', '-']],        // 原错误标F19，实际是减号/下划线键（键盘标注 -/_）
  [190, ['Period', '.', '.']],       // 原错误标F20，实际是句号/大于号键（键盘标注 ./>）
  [191, ['Slash', '/', '/']],         // 原错误标F21，实际是斜杠/问号键（键盘标注 /?）
  [192, ['Backquote', '`', '`']],    // 原错误标F22，实际是反引号/波浪号键（键盘标注 `/~，即你说的·键）
  [193, ['F23', 'F23', 'F23']],        // 真实F23键，无冲突
  [194, ['F24', 'F24', 'F24']] 
]);

// 禁止使用的键盘键码 'F1', 'F2', 'F3', 'F4', 'F5', 'F6', 'F7', 'F8', 'F9', 'F10', 'F11', 'F12', 'Meta', 'OS'
const disabledKeyCodeSet = new Set([112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 91, 92, 93])

/**
 * 键盘键码转换器
 * 用于将物理按键键码转换为W3C标准键码
 * 并提供键码信息查询功能
 */
export class keyboardConverter {
  private keyMap:any
  private disabledKeyCodeSet:Set<number>
  constructor() {
    this.keyMap = keyMap
    this.disabledKeyCodeSet = disabledKeyCodeSet
  }

  getKeyInfoByKeyCode(keyCode: number) {
    if(!this.isValidKeyCode(keyCode)){
      return null;
    }
    return this.keyMap.get(keyCode)
  }

  /**
  * 检查键码是否有效
  * @param {number} keyCode - 键盘键码
  * @returns {boolean} 是否有效
  */
  isValidKeyCode(keyCode:number):boolean{
    return this.keyMap.has(keyCode);
  }

  /**
  * 检查键码是否被禁用
  * @param {number} keyCode - 键盘键码
  * @returns {boolean} 是否被禁用
  */
  isDisabledKeyCode(keyCode:number):boolean{
    return this.disabledKeyCodeSet.has(keyCode);
  }
}
export default keyboardConverter;